export default function (strings, ...args) {
  var result = strings[0]
  for (var s = 1, l = strings.length; s < l; s++) {
    var string = strings[s]
    result += encodeURIComponent(args[s - 1]) + string
  }
  return result
}
